import React from "react";
import NumericInputPack from "components/NumericInputPack";

const NutrientInputPack = (props) => {
    const validation = props.validation[props.id] || {};
    return <NumericInputPack name={props.id} label={props.label} type={props.type} key={props.key} dataWidth="15" disabled={props.disabled} placeholder="" requiredLabel={false} val={validation} onChange={(e) => props.onChange({ type: props.type ? props.type : "nutrients", key: props.key, nutrient: props.nutrient, id: props.id }, e)} decimalPlaces={props.decimalPlaces || 1} id={props.id} value={props.value} />;
};

export default NutrientInputPack;
